import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styles from './style.module.less'
import store from './store'
import { Pagination, Button } from 'hljd'
import { HeaderView } from '@merchant-backend/common-components'

const TITLE = {
  '1': '人气推荐',
  '2': '本季热卖',
  '3': '超值特价',
  '4': '团购套餐'
}

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    const {
      params: { id },
      location: {
        query: { ids, count }
      }
    } = this.props
    store.hot_tag = id
    store.ids = ids ? ids.split(',') : []
    store.count = +count
    store.checked = ids ? ids.split(',') : []
  }

  componentDidMount() {
    store.getList()
  }

  render() {
    const { list, checked, ids, count, hot_tag, current, total } = store
    let title = TITLE[hot_tag]

    let header = [
      <a href="#/localMerchant/marketingTools?key=17">套餐热标</a>,
      title
    ]
    let extra = (
      <div className={styles.operate}>
        已选择套餐：{checked.length}/{ids.length + count}
        <Button onClick={store.addTag} disabled={list.length == 0}>
          确定
        </Button>
        <Button onClick={store.reSet} disabled={list.length == 0}>
          取消
        </Button>
      </div>
    )
    return (
      <HeaderView
        contentStyle={{ padding: 0 }}
        header={header}
        title={title}
        extra={extra}
      >
        <ul className={styles.item}>
          {(list || []).map(({ id, cover_path, title, actual_price }) => (
            <li key={id}>
              <img
                src={
                  cover_path
                    ? cover_path + '?imageView2/1/w/280/h/174/format/webp'
                    : ''
                }
              />
              <div className={styles.detail}>
                <div className={styles.txt}>
                  <p>{title}</p>
                  <p>￥{actual_price}</p>
                </div>
                <div className={styles.checkBtn} onClick={store.doCheckTag(id)}>
                  {checked.join().indexOf(id) > -1 ? (
                    <img src="http://qnm.hunliji.com/o_1b3eenu5b1f811og9183r1im7tu4h.png" />
                  ) : (
                    <img src="http://qnm.hunliji.com/o_1b3een44u1qcro7q3p512a939c.png" />
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
        <div className={styles.page}>
          <Pagination
            current={current}
            total={total}
            onChange={store.setPage}
            pageSize={15}
          />
        </div>
      </HeaderView>
    )
  }
}
